import React from 'react';
import styles from '../../index.module.scss';
import Button from 'components/Button';
import Icon from 'components/Icon';
import toolsEventMap from 'components/ReaderTools/toolsEventMap';
import { withTranslation } from 'react-i18next';

const ReaderToolFlipPageComponent = ({ t, type, clickHandlerParameters: [book, LRFlip] = [] }) => {
    return (
        <Button
            key={type}
            onClick={() => toolsEventMap[type].clickHandler(book, LRFlip)}
            title={t(toolsEventMap[type].title[LRFlip])}
        >
            <Icon name={toolsEventMap[type].icon} />
            <div className={styles.text}>{t(toolsEventMap[type].title[LRFlip])}</div>
        </Button>
    );
};

export default withTranslation()(ReaderToolFlipPageComponent);
